import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService } from '../../_services/usuario.service';
import { Usuario, EUsuarioRol } from '../../../common/usuario';
import * as _ from 'lodash';
import { SocketService } from '../../_services/socket.service';

@Component({
    selector: 'admin-menu',
    styles: [require('../admin.component.css')],
    template: require('./adminMenu.component.html')
})
export class AdminMenuComponent implements OnInit {
        
    private vm = EVistas; // variable usada en la vista
    private _rol = EUsuarioRol;
    
    @Input('menu') stats: ITopMenu = { }; // Variable que maneja lo que se muestra en el top menu
    
    @Output() operacion = new EventEmitter<IOperacion>();
    
    constructor(private $usuario: UsuarioService, private $router: Router) { }

    ngOnInit() { }

    /**
     * Función para retornar a la vista por defecto
     */
    //<editor-fold defaultstate="collapsed" desc="home(): void">
    home(): void {
        this.$router.navigateByUrl('/admin');
    }
    //</editor-fold>
    
    /**
     * Función para cerrar sesión
     */
    //<editor-fold defaultstate="collapsed" desc="cerrarSesion(): void">
    cerrarSesion(): void {
        this.$usuario.cerrarSesion()
            .subscribe(
                () => {
                    console.log('out');
                    this.$router.navigateByUrl('/login');
                },
                err => console.warn(err)
            )
    }
    //</editor-fold>
    
    /**
     * Función para ejecutar operaciones entre Componentes
     */
    //<editor-fold defaultstate="collapsed" desc="setOperacion(vista: string, valor: string )">
    setOperacion(vista: EVistas, valor?: string ) {
        let usr = this.$usuario.usuario;
        if ( usr.permisos <= this._rol.MANAGER || !valor || 
            (usr.permisos === this._rol.SUPER && _.findIndex(usr.manager, ['cola', valor]) > -1) 
           )
            this.operacion.emit(<IOperacion>{ vista: vista, subVista: valor});
    }
    //</editor-fold>
    
    validar(queueName: string): boolean {
        let index = _.findIndex(this.$usuario.usuario.manager, ['cola', queueName]);
        return index > -1 ? true: false;
    }
}

//<editor-fold defaultstate="collapsed" desc="export interface ITopMenu">
export interface ITopMenu {
    current_view?: EVistas, 
    nombre?: string, 
    menu?: string[],
    stats?: {
        nombre: string, 
        valor: string
    }[]
}
//</editor-fold>

//<editor-fold defaultstate="collapsed" desc="export interface IOperacion">
export interface IOperacion {
    vista: EVistas,
    subVista: string
}
//</editor-fold>

//<editor-fold defaultstate="collapsed" desc="export enum EVistas">
export enum EVistas {
    EXTENSIONES = <any>"Extensiones",
    GRUPOS = <any>"Grupos de Extensiones",
    INFORMES = <any>"Registros de llamadas",
    ESTADISTICAS = <any>"Estadísticas",
    AGENTES = <any>"Agentes",
    CALLCENTER = <any>"Callcenter",
    CALLCENTER_REPORTES = <any>"Registros de llamadas Callcenter",
    AGENTES_REPORTES =<any>"Informe de Agentes",
    CALLCENTER_STATS = <any>"Informes de Callcenter",
    IVR = <any>"IVR & DID's",
    TRONCALES = <any>"Troncales",
    SISTEMA = <any>"Sistema",
    USUARIO = <any>"Usuarios & Permisos",
    TIPIFICACION = <any>"Tipificación & Clasificación",
    CALLBACK = <any>"Callback",
    POLLS = <any>"Encuestas de Servicio"
}
//</editor-fold>




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/adminmenu/adminMenu.component.ts